import { createPlayerManagerStore } from '@tunein/web-player-manager/react';
import type { StateCreator } from 'zustand';

export interface PlayerState {
  popout: {
    showButton?: boolean;
    isDialogOpen?: boolean;
    externalUrl?: string;
  };
}

export interface PlayerActions {
  setPopoutState: (popoutState: PlayerState['popout']) => void;
}

export type PlayerStore = PlayerState & PlayerActions;

const initialState: PlayerState = {
  popout: {
    showButton: false,
    isDialogOpen: false,
    externalUrl: '',
  },
};

export function createPlayerStore() {
  const extraStateCreator: StateCreator<PlayerStore> = (set) => ({
    ...initialState,
    setPopoutState: (popout: PlayerState['popout']) =>
      set((prevState) => ({ popout: { ...prevState.popout, ...popout } })),
  });

  return createPlayerManagerStore<PlayerStore>(extraStateCreator);
}
